import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=7023b57f&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
import style0 from "./Tag.vue?vue&type=style&index=0&id=7023b57f&prod&lang=less"
import style1 from "./Tag.vue?vue&type=style&index=1&id=7023b57f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7023b57f",
  null
  
)

export default component.exports